export default function setContestReleaseAction(contestRelease) {

    return {
        type: 'SET_TO_CONTEST',
        payload: contestRelease
    }
}